import axios from "axios";

const instance = axios.create({
  baseURL: "https://my-portfolio-backend-production-0279.up.railway.app", // Update for production
  timeout: 10000,
});

export default instance;
